import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  const isPrivacy = type === 'privacy';
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.25
    }} className="bg-slate-800 border border-slate-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-36">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-700" data-id="element-37">
          <h3 className="text-xl font-bold text-white" data-id="element-38">
            {isPrivacy ? 'Políticas de Privacidad' : 'Términos de Uso'}
          </h3>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-slate-700 transition-colors text-slate-400 hover:text-white" data-id="element-39">
            <X className="w-5 h-5" data-id="element-40" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-41">
          {isPrivacy ? <>
              <p className="text-slate-400 text-xs" data-id="element-42">
                Última actualización: Febrero 2026
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-43">
                1. Información que Recopilamos
              </h4>
              <p data-id="element-44">
                Al adquirir el Método "Caja de Oro", recopilamos la información
                necesaria para procesar tu compra, incluyendo: nombre, dirección
                de correo electrónico y datos de pago. No almacenamos
                información de tarjetas de crédito directamente; todos los pagos
                son procesados por plataformas de pago seguras de terceros.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-45">
                2. Uso de la Información
              </h4>
              <p data-id="element-46">
                Utilizamos tu información personal únicamente para: entregar el
                producto digital adquirido, enviarte actualizaciones
                relacionadas con tu compra, y brindarte soporte al cliente. No
                vendemos, alquilamos ni compartimos tu información personal con
                terceros con fines de marketing.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-47">
                3. Protección de Datos
              </h4>
              <p data-id="element-48">
                Implementamos medidas de seguridad razonables para proteger tu
                información personal contra acceso no autorizado, alteración o
                destrucción. Sin embargo, ningún método de transmisión por
                Internet es 100% seguro.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-49">4. Cookies</h4>
              <p data-id="element-50">
                Nuestro sitio puede utilizar cookies para mejorar tu experiencia
                de navegación y analizar el tráfico del sitio. Puedes configurar
                tu navegador para rechazar cookies, aunque esto podría afectar
                algunas funcionalidades.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-51">
                5. Derechos del Usuario
              </h4>
              <p data-id="element-52">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal en cualquier momento. Para ejercer estos derechos,
                contáctanos a través de nuestros canales de soporte.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-53">
                6. Cambios a esta Política
              </h4>
              <p data-id="element-54">
                Nos reservamos el derecho de actualizar esta política de
                privacidad en cualquier momento. Los cambios serán publicados en
                esta página con la fecha de actualización correspondiente.
              </p>
            </> : <>
              <p className="text-slate-400 text-xs" data-id="element-55">
                Última actualización: Febrero 2026
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-56">
                1. Aceptación de los Términos
              </h4>
              <p data-id="element-57">
                Al acceder y utilizar este sitio web y adquirir el Método "Caja
                de Oro", aceptas estar sujeto a estos términos de uso. Si no
                estás de acuerdo con alguno de estos términos, no debes utilizar
                este sitio ni adquirir el producto.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-58">
                2. Descripción del Producto
              </h4>
              <p data-id="element-59">
                El Método "Caja de Oro" es un producto digital educativo (guía
                en formato PDF y materiales complementarios) que enseña
                estrategias de reventa de productos de liquidación. Los
                resultados pueden variar según el esfuerzo, dedicación y
                circunstancias individuales de cada persona.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-60">
                3. Uso del Producto
              </h4>
              <p data-id="element-61">
                El contenido adquirido es para uso personal y no comercial.
                Queda prohibida la reproducción, distribución, modificación o
                reventa del material sin autorización expresa por escrito.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-62">
                4. Exención de Responsabilidad
              </h4>
              <p data-id="element-63">
                Los ingresos y resultados mencionados son ejemplos ilustrativos
                y no constituyen una garantía de ganancias. El éxito depende de
                múltiples factores individuales. No nos hacemos responsables por
                decisiones financieras tomadas basándose en el contenido del
                producto.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-64">
                5. Propiedad Intelectual
              </h4>
              <p data-id="element-65">
                Todo el contenido del Método "Caja de Oro", incluyendo textos,
                gráficos, logotipos y materiales descargables, está protegido
                por derechos de autor y es propiedad exclusiva de Método Caja de
                Oro.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-66">
                6. Política de Reembolso
              </h4>
              <p data-id="element-67">
                Debido a la naturaleza digital del producto y su entrega
                inmediata, todas las ventas son finales. Si experimentas
                problemas técnicos para acceder al contenido, contáctanos y te
                ayudaremos a resolverlo.
              </p>

              <h4 className="text-white font-semibold text-base" data-id="element-68">
                7. Limitación de Responsabilidad
              </h4>
              <p data-id="element-69">
                En ningún caso seremos responsables por daños indirectos,
                incidentales o consecuentes que surjan del uso o la
                imposibilidad de uso del producto adquirido.
              </p>
            </>}
        </div>
      </motion.div>
    </motion.div>;
}
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-slate-950 py-8 text-center text-slate-500 text-sm" data-id="element-70">
        <div className="container mx-auto px-4" data-id="element-71">
          <p data-id="element-72">
            © {new Date().getFullYear()} Método Caja de Oro. Todos los derechos
            reservados.
          </p>

          <div className="flex items-center justify-center gap-4 mt-4 mb-4" data-id="element-73">
            <button onClick={() => setActiveModal('privacy')} className="text-slate-400 hover:text-amber-400 transition-colors underline underline-offset-2 cursor-pointer" data-id="element-74">
              Políticas de Privacidad
            </button>
            <span className="text-slate-600" data-id="element-75">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-slate-400 hover:text-amber-400 transition-colors underline underline-offset-2 cursor-pointer" data-id="element-76">
              Términos de Uso
            </button>
          </div>

          <p className="text-xs text-slate-600" data-id="element-77">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-78">
        {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-79" />}
      </AnimatePresence>
    </>;
}